import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Debug } from "../../../Molecules/Forms/Debug";
import { Button, Grid, SubmitButton, Tabs, FranchiseForm, Dialog, UserForm, BillingInfoForm, makeStyles } from "../../../";
var franchiseSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio"),
  language: Yup.string(),
  currency: Yup.string(),
  billingInfo: Yup.object().shape({
    address: Yup.string(),
    name: Yup.string(),
    vat_number: Yup.string(),
    tax_rate: Yup.string().required()
  })
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogFranchise = function DialogFranchise(props) {
  var _useState = useState("data"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1]; // console.log("DialogFranchise props", props);


  var initialValues = {
    name: "",
    language: "es",
    currency: "EUR",
    country: "ES",
    users: [{
      name: "",
      email: "@sportmadness.es"
    }],
    billingInfo: {
      isLegalEntity: false
    }
  };

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var classes = useStyles();
  var tabs = [{
    label: "Franchise Data",
    value: "data"
  }, {
    label: "Users",
    value: "users"
  }, {
    label: "Billing Info",
    value: "billing"
  }];
  var tabsEdit = [{
    label: "Franchise Data",
    value: "data"
  }, {
    label: "Billing Info",
    value: "billing"
  }];
  var title = "";

  var contentTabHandler = function contentTabHandler(values) {
    switch (value) {
      case "data":
        return /*#__PURE__*/React.createElement(FranchiseForm, {
          values: values,
          mode: props.variant
        });

      case "users":
        return /*#__PURE__*/React.createElement(UserForm, {
          values: values,
          mode: props.variant
        });

      case "billing":
        return /*#__PURE__*/React.createElement(BillingInfoForm, {
          values: values,
          mode: props.variant,
          taxes: props.taxes
        });

      default:
        return /*#__PURE__*/React.createElement(FranchiseForm, {
          values: values,
          mode: props.variant
        });
    }
  };

  if (props.variant === "edit") {
    title = "Edit Franchise";
  } else if (props.variant === "view") {
    title = "View Franchise";
  } else if (props.variant === "add") {
    title = "Add Franchise";
  }

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: title,
    open: props.open,
    onClose: props.onClose,
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues,
    validationSchema: franchiseSchema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;

      // setTimeout(() => {
      //   alert(JSON.stringify(values, null, 2));
      // }, 500);
      if (props.variant === "add") {
        props.createFranchise(values);
        resetForm = {
          name: "",
          language: "es",
          currency: "EUR"
        };
        props.onClose();
      } else if (props.variant === "edit") {
        props.editFranchise(values);
        props.onClose();
      }
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: value,
        onChange: handleTabs,
        variant: "standard",
        indicatorColor: "primary",
        textColor: "primary",
        contentTabs: props.variant === "add" ? tabs : tabsEdit
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, contentTabHandler(values)), props.variant !== "view" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        className: classes.mr30,
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, "Save"))));
    }
  })))];
};

export { DialogFranchise };